/* Meek Designs site-wide motion + feedback layer */
(() => {
  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal for sections and grid items below the first screen.
  const reveal = () => {
    if (reducedMotion || !('IntersectionObserver' in window)) return;
    const targets = [];
    document.querySelectorAll('main .shopify-section:not(:first-child)').forEach((section) => {
      const items = section.querySelectorAll('.grid__item, .setup-gallery__item, .rich-text__blocks > *, .title-wrapper-with-link, .title-wrapper');
      if (items.length) items.forEach((el, i) => { el.style.setProperty('--fx-i', i % 8); targets.push(el); });
      else targets.push(section);
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    const vh = window.innerHeight;
    targets.forEach((el) => {
      if (el.getBoundingClientRect().top < vh * 0.9) return; // already on screen: leave it alone
      el.classList.add('fx-reveal');
      io.observe(el);
    });
    root.classList.add('fx-ready');
  };

  // Mark the dark pricing band on the home page.
  const pricing = () => {
    document.querySelectorAll('.rich-text.color-accent-1, .color-accent-1 .rich-text').forEach((el) => {
      (el.closest('.rich-text') || el).classList.add('fx-pricing');
    });
  };

  // Sparkle burst + pulse when something goes in the cart.
  const burst = (btn) => {
    if (reducedMotion) return;
    const r = btn.getBoundingClientRect();
    const colors = ['#ffd27a', '#ff6fb5', '#7fd8ff', '#b6ff7a', '#fff3d6'];
    for (let i = 0; i < 18; i++) {
      const p = document.createElement('span');
      const a = (Math.PI * 2 * i) / 18 + Math.random() * 0.3;
      const dist = 50 + Math.random() * 60;
      p.className = 'fx-burst';
      p.style.left = `${r.left + r.width / 2}px`;
      p.style.top = `${r.top + r.height / 2}px`;
      p.style.setProperty('--dx', `${Math.cos(a) * dist}px`);
      p.style.setProperty('--dy', `${Math.sin(a) * dist}px`);
      p.style.setProperty('--c', colors[i % colors.length]);
      document.body.appendChild(p);
      p.addEventListener('animationend', () => p.remove());
    }
    btn.classList.remove('fx-added');
    void btn.offsetWidth;
    btn.classList.add('fx-added');
  };
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.action)) return;
    const btn = form.querySelector('.product-form__submit, [type="submit"]');
    if (btn) burst(btn);
  }, true);

  // Glass header after the first scroll.
  const onScroll = () => root.classList.toggle('fx-scrolled', window.scrollY > 24);
  window.addEventListener('scroll', onScroll, { passive: true });

  const boot = () => { pricing(); reveal(); onScroll(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
